import type { TenantProject } from "./interfaces";

/**
 * A URL-catalog project entry also names its tenant slug (`storage_org_slug`, ai_engine#3113):
 * the organization the server uses as `request.state.org_slug` for that project. It is null for
 * adopted projects. Kept beside `interfaces.ts`, which may not grow.
 */
type TenantProjectWithSlug = TenantProject & { storage_org_slug?: string | null };

export function projectStorageOrgSlug(project: TenantProject): string | null {
    return (project as TenantProjectWithSlug).storage_org_slug ?? null;
}
